/* eslint-disable react/require-default-props */
import React from 'react';
import AiManagementStatCard from 'components/atoms/ai_management_stat_card';
import AiManagementSummaryCard from 'components/atoms/ai_management_summary_card';
import AiManagementCollapsibleCard from 'components/molecules/ai_management_collapsible_card';
import {
  PossibleCompetitorPricing,
  PossibleCompetitorRankingDistribution,
} from 'services/actions/ai_management_possible_competitors';
import { count, percent, plural } from 'services/ai_management_format';
import { Bar, Distribution } from './styles';

interface AiManagementCompetitorPricingProps {
  pricing: PossibleCompetitorPricing;
  className?: string;
}

const BUCKETS: Array<{ key: keyof PossibleCompetitorRankingDistribution; label: string }> = [
  { key: 'primeiro', label: '1º lugar' },
  { key: 'segundo_terceiro', label: '2º a 3º' },
  { key: 'quarto_decimo', label: '4º a 10º' },
  { key: 'acima_decimo', label: 'Acima do 10º' },
  { key: 'sem_classificacao', label: 'Sem classificação' },
];

const AiManagementCompetitorPricing: React.FC<AiManagementCompetitorPricingProps> = ({
  pricing,
  className = '',
}) => {
  const total = BUCKETS.reduce((sum, bucket) => sum + pricing.distribuicao[bucket.key], 0);
  const stats = [
    { label: '1º lugar', value: percent(pricing.pct_primeiro) },
    { label: 'Top 3', value: percent(pricing.pct_top3) },
    { label: 'Com classificação', value: count(pricing.com_classificacao) },
  ];

  return (
    <AiManagementCollapsibleCard title="Preço competitivo" className={className}>
      {pricing.texto ? (
        <AiManagementSummaryCard className="mb-3">{pricing.texto}</AiManagementSummaryCard>
      ) : null}

      <div className="row mb-4">
        {stats.map((stat) => (
          <div key={stat.label} className="col-sm-4 mb-3 mb-sm-0">
            <AiManagementStatCard value={stat.value} label={stat.label} />
          </div>
        ))}
      </div>

      <Distribution>
        {BUCKETS.map((bucket) => {
          const value = pricing.distribuicao[bucket.key];
          const share = total ? Number(((value / total) * 100).toFixed(1)) : 0;
          return (
            <div
              key={bucket.key}
              className="distribution-row"
              title={`${plural(value, 'item', 'itens')} (${percent(share)} do total)`}
            >
              <div className="distribution-label">{bucket.label}</div>
              <div className="distribution-track" aria-hidden>
                <Bar $share={share} $bucket={bucket.key} />
              </div>
              <div className="distribution-value text-muted">{count(value)}</div>
            </div>
          );
        })}
      </Distribution>
    </AiManagementCollapsibleCard>
  );
};

export default AiManagementCompetitorPricing;
